import SJModal from "@/components/SJModal";
import {
  RefObject,
  useImperativeHandle,
  useState,
  useRef,
  useEffect,
} from "react";
import SJButton from "../SJButton";
import { useTranslation, Trans } from "react-i18next";
import "./index.scss";
import { AgreeType } from "logic/src/objects/session/types";
import i18next from "@/i18n";

export type TPolicyDialogProp = {
  show: (callback?: (confirm?: boolean) => void) => void;
};

const PolicyDialog = ({
  visible,
  onCancel,
  onOk,
}: {
  visible: boolean;
  onCancel: () => any;
  onOk: () => any;
}) => {
  const { t } = useTranslation();
  // const [open, setOpen] = useState(false);
  const handlerRef = useRef<(confirm?: boolean) => void>();

  const handlePolicy = (agreeType: AgreeType) => {
    window.open(`/policy?id=${agreeType}&lang=${i18next.language}`, "_blank");
  };

  return (
    <SJModal
      className="policy-wrap"
      open={visible}
      onCancel={onCancel}
      title={t("sensechat-106")} // "用户协议和信息政策"
      footer={
        <div className="policy-dialog-footer">
          <div className="policy-dialog-btns">
            <SJButton type="dashed" onClick={onCancel}>
              {t("sensechat-21")}
              {/* 取消 */}
            </SJButton>
            <SJButton type="primary" onClick={onOk}>
              {t("sensechat-107")}
              {/* 同意并继续 */}
            </SJButton>
          </div>
        </div>
      }
    >
      <div className="policy-dialog">
        <span className="policy-dialog-content">
          <Trans i18nKey={"sensechat-18"}>
            1. 感谢您信任并使用商量（Sensechat）大语言模型内测版。
            <br />
            2.我们非常重视您的个人信息和隐私保护，为了更好的保障您的个人权益，在您使用我们的产品前，请您认真阅读
            <span
              className="policy-dialog-highlight"
              onClick={() => handlePolicy(AgreeType.userPrivacy)}
            >
              《用户协议》
            </span>
            和
            <span
              className="policy-dialog-highlight"
              onClick={() => handlePolicy(AgreeType.infoCollect)}
            >
              《信息政策》
            </span>
            的全部内容，同意并接受全部条款后开始使用我们的产品和服务。
            <br />
            3.我们深知个人信息对您的重要性，我们将严格遵守有关法律法规，并采取相应的重要保护技术措施，尽力保护您的个人信息安全。
            <br />
            4.点击同意并继续，即表示您已经阅读
            <span
              className="policy-dialog-highlight"
              onClick={() => handlePolicy(AgreeType.userPrivacy)}
            >
              《用户协议》
            </span>
            和
            <span
              className="policy-dialog-highlight"
              onClick={() => handlePolicy(AgreeType.infoCollect)}
            >
              《信息政策》
            </span>
            的全部内容。
            <br />
          </Trans>
        </span>
      </div>
    </SJModal>
  );
};

export default PolicyDialog;

// 1. 感谢您信任并使用商量（SenseChat）大语言模型内测版。<1/><2/>2.我们非常重视您的个人信息和隐私保护，为了更好的保障您的个人权益，在您使用我们的产品前，请您认真阅读<4>《用户协议》</4>和<6><信息政策》</6>的全部内容，同意并接受全部条款后开始使用我们的产品和服务。<8/><9/>3.我们深知个人信息对您的重要性，我们将严格遵守有关法律法规，并采取相应的重要保护技术措施，尽力保护您的个人信息安全。<11/><12/>4.点击同意并继续，即表示您已经阅读<14>《用户协议》</14>和<16>《信息政策》</16>的全部内容。<18/>
